/* eslint-disable no-param-reassign */
import { InternalAxiosRequestConfig } from "axios";
import dayjs from "dayjs";
import { jwtDecode } from "jwt-decode";
import {
  getRefreshTokenFromOldAccess,
  getLegacyRefreshToken,
} from "./utils";

export async function requestAuthInterceptor(
  config: InternalAxiosRequestConfig,
) {
  // на всякий случай - если oldBaseApi идет в эндпоинт, обновляющий токен
  if (config.url?.includes(`/tokens/jwt/refresh`)) return config;

  const legacyAccessTokenLocal = localStorage.getItem("token");
  const accessTokenLocal = localStorage.getItem("newToken");

  // если токена второй версии ещё нет.
  if (legacyAccessTokenLocal && !accessTokenLocal) {
    const { accessToken } = await getRefreshTokenFromOldAccess(
      legacyAccessTokenLocal,
    );
    if (accessToken) {
      localStorage.setItem("newToken", accessToken);
    }
    config.headers.Authorization = `Bearer ${accessToken}`;
    return config;
  }

  if (legacyAccessTokenLocal) {
    const { exp: legacyExp } = jwtDecode(legacyAccessTokenLocal);
    if (dayjs().isAfter(dayjs.unix(legacyExp ?? 0))) {
      const newLegacyAccessToken = await getLegacyRefreshToken(
        legacyAccessTokenLocal,
      );
      localStorage.setItem("token", newLegacyAccessToken);
    }

    const { exp } = jwtDecode(accessTokenLocal ?? "");

    const newLegacyAccessToken = localStorage.getItem("token")!;

    if (dayjs().isAfter(dayjs.unix(exp ?? 0))) {
      const { accessToken } = await getRefreshTokenFromOldAccess(
        newLegacyAccessToken,
        accessTokenLocal,
      );
      if (accessToken) {
        localStorage.setItem("newToken", accessToken);
      }
    }

    /*
     * Чтобы не повторяться каждый раз и не присваивать Auth header
     * при каждом случае выше. Надеемся на кеширование со стороны браузера
     * */
    const resultToken = localStorage.getItem("newToken");

    config.headers.Authorization = `Bearer ${resultToken}`;

    return config;
  }

  return config;
}
